var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"38830dbf959331101b8caea88c7b7db011416eeb"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["prebuilt-ui@pluot-communications"]={id:"38830dbf959331101b8caea88c7b7db011416eeb"};
      